import { Directive, inject, input, linkedSignal, signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { ActivatedRoute } from '@angular/router';

/**
 * Gives a page-level board its page frame (`entity-board-top-level`): from the route's `topLevel` data, or an
 * explicit override. The host board sets `$embedded` so a board mounted inside a record tab never inherits its
 * list route's `topLevel` (routes inherit data, so a record under a top-level list would otherwise get the frame).
 */
@Directive({
  selector: '[entityBoardTopLevel]',
  standalone: true,
  host: {
    '[class.entity-board-top-level]': '$topLevel()',
  },
})
export class EntityBoardTopLevelDirective {

  public $topLevelOverride = input(false, { alias: 'topLevelOverride' });

  /** Set by the host board from its context: an embedded board takes no page frame from the route. */
  public readonly $embedded = signal(false);

  private route = inject(ActivatedRoute);

  private $routeData = toSignal(this.route.data);
  protected $topLevel = linkedSignal(() => {
    return this.$topLevelOverride() || (!this.$embedded() && !!this.$routeData()?.topLevel);
  });
}
